import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconCalendar = /*@__PURE__*/ proxyCustomElement(class WppIconCalendar extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-calendar", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.20833 3.875C4.47213 3.875 3.875 4.47213 3.875 5.20833V5.70831H16.125V5.20833C16.125 4.47213 15.5279 3.875 14.7917 3.875H5.20833ZM3.875 14.7917V7.20831H16.125V14.7917C16.125 15.5279 15.5279 16.125 14.7917 16.125H5.20833C4.47213 16.125 3.875 15.5279 3.875 14.7917ZM2.375 5.20833C2.375 3.6437 3.6437 2.375 5.20833 2.375H14.7917C16.3563 2.375 17.625 3.6437 17.625 5.20833V14.7917C17.625 16.3563 16.3563 17.625 14.7917 17.625H5.20833C3.6437 17.625 2.375 16.3563 2.375 14.7917V5.20833ZM7.50008 9.79167C7.50008 10.367 7.03371 10.8333 6.45841 10.8333C5.88312 10.8333 5.41675 10.367 5.41675 9.79167C5.41675 9.21637 5.88312 8.75 6.45841 8.75C7.03371 8.75 7.50008 9.21637 7.50008 9.79167ZM9.99992 10.8333C10.5752 10.8333 11.0416 10.367 11.0416 9.79167C11.0416 9.21637 10.5752 8.75 9.99992 8.75C9.42462 8.75 8.95825 9.21637 8.95825 9.79167C8.95825 10.367 9.42462 10.8333 9.99992 10.8333ZM7.50008 13.5417C7.50008 14.117 7.03371 14.5833 6.45841 14.5833C5.88312 14.5833 5.41675 14.117 5.41675 13.5417C5.41675 12.9664 5.88312 12.5 6.45841 12.5C7.03371 12.5 7.50008 12.9664 7.50008 13.5417ZM9.99992 14.5833C10.5752 14.5833 11.0416 14.117 11.0416 13.5417C11.0416 12.9664 10.5752 12.5 9.99992 12.5C9.42462 12.5 8.95825 12.9664 8.95825 13.5417C8.95825 14.117 9.42462 14.5833 9.99992 14.5833ZM14.5833 9.79167C14.5833 10.367 14.117 10.8333 13.5417 10.8333C12.9664 10.8333 12.5 10.367 12.5 9.79167C12.5 9.21637 12.9664 8.75 13.5417 8.75C14.117 8.75 14.5833 9.21637 14.5833 9.79167Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-calendar-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-calendar", "wpp-icon-calendar-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-calendar-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-calendar-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconCalendar);
      }
      break;
  } });
}

export { WppIconCalendar as W, defineCustomElement as d };
